import Cookies from 'js-cookie'
import Config from '@/utils/index'

const TokenKey = Config.TokenKey

export function getToken(tokenPar) {
  let token = Cookies.get(TokenKey)
  if (!token && tokenPar) {
    token = tokenPar
    setToken(token)
  }
  return token
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function addTokenParam(url) {
  return url + '?token=' + getToken() + '&company_id=' + getCompanyId()
}



// WEBPACK FOOTER //
// ./src/utils/auth.js